import { getStore } from '@ingka/singleton-store';
const ICON_STORE_ID = 'skapa-icon-store';
// The store will be initialized with a generic Map inside the getStore on first request.
const iconStore = getStore(ICON_STORE_ID);
export const registerIcon = (name, paths) => {
    if (!iconStore.has(name))
        iconStore.set(name, paths);
};
export const getPaths = (name) => {
    if (!name)
        return;
    const result = iconStore.get(name);
    if (!result)
        console.error(`The icon: '${name}' has not been loaded yet!\nDid you forget to import '@ingka/icon-store/${name}'?`);
    return result;
};
